import React, { useState, useEffect, useCallback } from "react";
import Col from "react-bootstrap/Col";
import Card from "react-bootstrap/Card";
import Skeleton from "react-loading-skeleton";
import axios from "axios";

const ProjectCard = ({ value }) => {
  const {
    name,
    description,
    svn_url,
    stargazers_count,
    languages_url,
    pushed_at,
  } = value;
  return (
    <Col md={6}>
      <Card className="project-card mb-4">
        <Card.Body>
          <div className="d-flex justify-content-between align-items-start mb-2">
            <Card.Title as="h5" className="mb-0">
              {name || <Skeleton width={140} />}
            </Card.Title>
            {svn_url && (
              <a
                href={svn_url}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="View repo on GitHub"
                className="project-card-link"
              >
                <i className="fab fa-github" />
              </a>
            )}
          </div>
          <Card.Text className="project-card-desc">
            {!description ? (name ? "" : <Skeleton count={2} />) : description}
          </Card.Text>
          {value ? (
            <Meta
              star_count={stargazers_count}
              languages_url={languages_url}
              pushed_at={pushed_at}
            />
          ) : (
            <Skeleton />
          )}
        </Card.Body>
      </Card>
    </Col>
  );
};

const Meta = ({ star_count, languages_url, pushed_at }) => {
  const [topLanguage, setTopLanguage] = useState(null);

  const fetchLanguages = useCallback(async () => {
    if (!languages_url) return;
    try {
      const response = await axios.get(languages_url);
      const entries = Object.entries(response.data);
      if (entries.length) {
        entries.sort((a, b) => b[1] - a[1]);
        setTopLanguage(entries[0][0]);
      }
    } catch (error) {
      console.error(error.message);
    }
  }, [languages_url]);

  useEffect(() => {
    fetchLanguages();
  }, [fetchLanguages]);

  if (!languages_url) return <Skeleton width={180} />;

  const updated = pushed_at ? formatUpdatedAt(pushed_at) : null;

  return (
    <p className="project-card-meta mb-0">
      {topLanguage && <span>{topLanguage}</span>}
      {topLanguage && <span className="dot">&middot;</span>}
      <span>
        <i className="fas fa-star" /> {star_count}
      </span>
      {updated && <span className="dot">&middot;</span>}
      {updated && <span>Updated {updated}</span>}
    </p>
  );
};

const formatUpdatedAt = (pushed_at) => {
  const date = new Date(pushed_at);
  const hours = Math.trunc((Date.now() - date.getTime()) / 1000 / 60 / 60);

  if (hours < 24) {
    if (hours < 1) return "just now";
    return `${hours} ${hours === 1 ? "hour" : "hours"} ago`;
  }
  return new Intl.DateTimeFormat("en-US", {
    day: "numeric",
    month: "long",
    year: "numeric",
  }).format(date);
};

export default ProjectCard;
